import { Component } from '@angular/core';
import { ErrorService } from 'src/app/core/error.service';
import { OrderSummary, OrdersService } from 'src/app/core/orders.service';

@Component({
  selector: 'app-orders-summary',
  templateUrl: './orders-summary.component.html',
  styleUrls: ['./orders-summary.component.scss'],
})
export class OrdersSummaryComponent {
  is_summary_request_running: boolean = true;
  summary?: OrderSummary;

  constructor(private error_service: ErrorService, private orders_service: OrdersService) {}

  ngOnInit(): void {
    this.readSummary();
  }

  onRefresh(): void {
    this.readSummary();
  }

  readSummary(): void {
    this.is_summary_request_running = true;
    this.orders_service.readSummary().subscribe({
      next: response => {
        this.summary = response.data;
        this.is_summary_request_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_summary_request_running = false;
      },
    });
  }
}
